import {Input} from '@mantine/core';
import classes from './input.module.css';

export const InputTheme = Input.extend({
  classNames: {
    input: classes.input,
  },
})